import React, { useState, useRef, useEffect } from "react";
import Image from "components/Elements/Image/Image.tsx";
import classNames from "classnames";
import Form from "components/Reusable/Form/Form.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Button from "components/Elements/Button/Button.js";
import config from "config";
import Icon from "components/Elements/Icon/Icon.tsx";
import useBucketName from "hooks/useBucketName.ts";
import { MultipleShareInput } from "components/Reusable/SideBar/Share/MultipleShareInput.js";
import { EmbedShareFields } from "./EmbedShareFields.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";
import { useContent } from "contexts/contentContext/contentContext.js";

import {
  FacebookShareButton,
  FacebookIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon,
  RedditShareButton,
  RedditIcon,
  TelegramShareButton,
  TelegramIcon,
  TumblrShareButton,
  TumblrIcon,
  TwitterShareButton,
  TwitterIcon,
  VKShareButton,
  VKIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

const ShareFormModal = ({ userName, titlePage, backgroundImageListURLS }) => {
  const [fields, setFields] = useState(EmbedShareFields);
  const { getUserData } = useUser();
  const { addToast } = useToasts();
  const userData = getUserData();
  const [isCopied, setIsCopied] = useState(false);
  const {
    getTextByKey,
    getBasicSettingsData,
    getLanguageCulture,
    getLanguage,
  } = useContent();
  const [shareMailForm, setShareMailForm] = useState(false);
  const [formLink, setFormLink] = useState("");
  const [selectedForm, setSelectedForm] = useState("all");
  const textAreaRef = useRef(null);
  const title = getTextByKey("sharing-embedpage-title");
  const summary = getTextByKey("sharing-embedpage-summary");
  const source = "JUMBOmail.me";
  const image =
    backgroundImageListURLS.length > 0
      ? backgroundImageListURLS[0]
      : `${config.api.resource}/assets/images/jumbomail-logo-black.svg`;
  const hashtags = getTextByKey("social-media-share-hashtags").split(",");
  //show more button logic
  const [isShowMore, setIsShowMore] = useState(false);
  const showMoreClass = classNames(
    "share-icons-container ",
    isShowMore ? "container-height-expended" : ""
  );
  const bucketName = useBucketName();

  //{getTextByKey("personal-page-copy-code")}
  useEffect(() => {
    if (shareMailForm) {
      setFields((prev) => {
        return {
          ...prev,
          ShareToEmailRecipientTitle: {
            element: "customelement",
            fieldKey: "ShareToEmailRecipientTitle",
            validation: {
              validate: (array) =>
                array.length > 0 || getTextByKey("invalid-email-text"),
            },
            render: (props) => (
              <MultipleShareInput
                {...props}
                //defaultValue={email}
                recipientsList={null}
              />
            ),
          },
        };
      });
    }
  }, [shareMailForm]);

  //Copy the textarea value
  const copyTextAreaToClibord = () => {
    textAreaRef.current.select();
    document.execCommand("copy");
    setIsCopied(true);
    // This is just personal preference.
    // I prefer to not show the the whole text area selected.
  };

  useEffect(() => {
    if (bucketName) {
      const baseUrl =
        "https://" +
        bucketName +
        "/" +
        getLanguage() +
        "/page/" +
        userName.toLowerCase();
      if (
        selectedForm &&
        selectedForm !== "all" &&
        selectedForm.Embed_Dynamic_Id &&
        userName
      ) {
        setFormLink(baseUrl + "/" + selectedForm.Embed_Dynamic_Id);
      } else if (selectedForm && userName) {
        setFormLink(baseUrl);
      }
    }
  }, [userName, selectedForm, bucketName]);
  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  }, [isCopied]);
  const handleSubmit = async (body) => {
    const newBody = {
      SenderEmail: body.ShareToEmailSenderTitle,
      Recipients: body.ShareToEmailRecipientTitle,
      Body: body.ShareToEmailBodyTitle,
      userCulture: getLanguageCulture(),
      Subject: titlePage ? titlePage : userName,
      EmbedPageUrl: formLink,
      RecaptchaResponse: body.recaptchaResponse,
    };

    const response = await apiRequest(
      "Mails",
      "ShareMailEmbedForm",
      newBody,
      "POST"
    );
    if (response.status === "success") {
      addToast(getTextByKey("success-share-form"), {
        appearance: "success",
      });
    }

    return response;
  };

  return (
    <div className="share-form-modal">
      <div className="title">{getTextByKey("embed-page-share-title")}</div>
      <div className="body">
        <div className="get-link">
          <label for="embed-page-link" className="get-link-title">
            <span>{getTextByKey("get-the-link-embed-share")}</span>
            <a
              target="_blank"
              href={formLink}
              rel="noopener noreferrer"
              aria-label="form-link"
            >
              <Image name="personal/get-link" title="" alt="" />
            </a>
          </label>

          <div className="input-div">
            <div className="script-code">
              <input
                id="embed-page-link"
                type="text"
                readOnly
                ref={textAreaRef}
                value={formLink}
              ></input>
            </div>
            <div className="copy-icon" onClick={() => copyTextAreaToClibord()}>
              <Icon title="" name="copy-b" />
              {isCopied && (
                <div>
                  <span className="text">{getTextByKey("copied-text")}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        {formLink && (
          <div className="social-share">
            <span className="text">{getTextByKey("share-on-social")}</span>
            <div className="links">
              <div className={showMoreClass}>
                <Tooltip id="share-mail-id" tooltipTextKey={"share-via-mail"}>
                  <Button
                    style={{ marginBottom: !isShowMore && "5px" }}
                    roundicon
                    onClick={() => {
                      //setIsShareViaLink(false);
                      setShareMailForm(true);
                    }}
                  >
                    <Icon name={"envelope-solid"} />
                  </Button>
                </Tooltip>
                <Tooltip id="share-fb-id" tooltipTextKey={"Facebook"}>
                  <FacebookShareButton
                    url={formLink}
                    quote={title}
                    hashtag={hashtags}
                  >
                    <FacebookIcon size={44} round />
                  </FacebookShareButton>
                </Tooltip>
                <Tooltip id="share-whatsapp-id" tooltipTextKey={"Whatsapp"}>
                  <WhatsappShareButton
                    url={formLink}
                    title={title}
                    windowWidth={window.innerWidth / 1.5}
                    windowHeight={window.innerHeight / 1.5}
                  >
                    <WhatsappIcon size={44} round />
                  </WhatsappShareButton>
                </Tooltip>
                <Tooltip id="share-twitter-id" tooltipTextKey={"Twitter"}>
                  <TwitterShareButton
                    url={formLink}
                    title={title}
                    hashtags={hashtags.map((item) =>
                      item.includes("#") ? item.split("#")[1] : item
                    )}
                  >
                    <TwitterIcon size={44} round className="" />
                  </TwitterShareButton>
                </Tooltip>
                {/* show more button */}
                {!isShowMore ? (
                  <Tooltip id="share-show-more-id" tooltipTextKey={"show-more"}>
                    <Button
                      style={{ marginBottom: "5px" }}
                      red
                      roundicon
                      onClick={() => setIsShowMore(true)}
                    >
                      <Icon name="plus" />
                    </Button>
                  </Tooltip>
                ) : (
                  <>
                    <Tooltip
                      id="share-messenger-id"
                      tooltipTextKey={"Messenger"}
                    >
                      <FacebookMessengerShareButton
                        url={formLink}
                        quote={title}
                        hashtag={hashtags}
                        appId={getBasicSettingsData().facebookAppId}
                      >
                        <FacebookMessengerIcon
                          size={44}
                          round
                          className="share-icon-faded"
                        />
                      </FacebookMessengerShareButton>
                    </Tooltip>
                    <Tooltip id="share-linkedin-id" tooltipTextKey={"Linkedin"}>
                      <LinkedinShareButton
                        url={formLink}
                        title={title}
                        summary={summary}
                        source={source}
                      >
                        <LinkedinIcon
                          size={44}
                          round
                          className="share-icon-faded"
                        />
                      </LinkedinShareButton>
                    </Tooltip>
                    <Tooltip
                      id="share-pinterest-id"
                      tooltipTextKey={"Pinterest"}
                    >
                      <PinterestShareButton
                        url={formLink}
                        description={summary}
                        media={image}
                      >
                        <PinterestIcon
                          size={44}
                          round
                          className="share-icon-faded"
                        />
                      </PinterestShareButton>
                    </Tooltip>
                    <Tooltip id="share-reddit-id" tooltipTextKey={"Reddit"}>
                      <RedditShareButton url={formLink} title={title}>
                        <RedditIcon
                          size={44}
                          round
                          className="share-icon-faded"
                        />
                      </RedditShareButton>
                    </Tooltip>
                    <Tooltip id="share-telegram-id" tooltipTextKey={"Telegram"}>
                      <TelegramShareButton url={formLink} title={title}>
                        <TelegramIcon
                          size={44}
                          round
                          className="share-icon-faded"
                        />
                      </TelegramShareButton>
                    </Tooltip>
                    <Tooltip id="share-tumblr-id" tooltipTextKey={"Tumblr"}>
                      <TumblrShareButton
                        url={formLink}
                        title={title}
                        caption={summary}
                      >
                        <TumblrIcon
                          size={44}
                          round
                          className="share-icon-faded"
                        />
                      </TumblrShareButton>
                    </Tooltip>

                    <Tooltip id="share-vk-id" tooltipTextKey={"VK"}>
                      <VKShareButton url={formLink} title={title} image={image}>
                        <VKIcon size={44} round className="share-icon-faded" />
                      </VKShareButton>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {shareMailForm && (
          <div className="share-mail">
            <Form
              fields={fields}
              onSubmit={handleSubmit}
              submitProps={{
                title: getTextByKey("share"),
                errorWithBackground: true,
              }}
              defaultValuesObj={{
                ShareToEmailSenderTitle: userData.UserName,
                ShareToEmailRecipientTitle: "",
                ShareToEmailBodyTitle: getTextByKey("sharing-embedpage-title"),
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareFormModal;
